import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { next } from '@ember/runloop';

export default class MwSmartSearchChat extends Component {
  @service chat;

  @tracked thread;

  constructor() {
    super(...arguments);

    next(() => {
      this.setInitialParams();
    });
  }

  setInitialParams() {
    // args.chat is either a Message or a Thread
    const chat = this.args.chat;
    // in case of Message there should be `thread` property, otherwise args.chat is a Thread
    if (chat.thread) {
      this.thread = chat.thread;
      this.message = chat;
    } else {
      this.thread = chat;
    }

    if (this.isThreadChatType || this.isGroupChatType) {
      let textServer = this.thread?.lastMessage?.textServer;
      const originalLastMsg = chat.lastMessage;

      if (typeof originalLastMsg !== 'undefined' && originalLastMsg !== null) {
        const originalText = originalLastMsg.text;

        if (typeof textServer === 'undefined' || textServer === null || textServer === '') {
          if (typeof originalText !== 'undefined' && originalText !== null && originalText !== '') {
            textServer = chat.lastMessage.textServer;
          }
        }
      }
      this.textServer = textServer;

      this.setDataForHighlight(chat);
    }
  }

  get isMessageChatType() {
    return this.args.chat.recordType === 'chatMessage';
  }

  get isThreadChatType() {
    return this.args.chat.recordType === 'chatThread';
  }

  get isGroupChatType() {
    return this.args.chat.messageType === 'group';
  }

  get isMultiUsersChat() {
    return this.thread?.isMultiUsersChat;
  }

  setDataForHighlight(chat) {
    this.thread.query = chat.query;
    this.thread.highlightStart = chat.highlightStart;
    this.thread.highlightEnd = chat.highlightEnd;
    this.thread.isFromSearch = true;
  }

  @action
  openChat(event) {
    if (event && event.target) {
      if (event.target.classList.contains('text-truncate_button')) return;
    }

    this.chat.transitionToThreadByIdOrOpenParticipants(this.thread.id, this.message?.id);
    this.args.closeSmartSearch();
  }
}
